import React from 'react';
import { Clock } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function CountdownBanner() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="bg-forest text-cream py-2 px-4 sticky top-0 z-50 shadow-md" data-id="element-136">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-sm font-medium" data-id="element-137">
        <div className="flex items-center gap-2" data-id="element-138">
          <span className="opacity-80" data-id="element-139">🌿 HOGAR NATURAL™</span>
        </div>
        <div className="flex items-center gap-2 bg-forest-dark px-3 py-1 rounded-full" data-id="element-140">
          <Clock className="w-4 h-4 text-terracotta" data-id="element-141" />
          <span data-id="element-142">Termina en:</span>
          <span className="font-mono font-bold text-terracotta tracking-wider" data-id="element-143">
            {hours} : {minutes} : {seconds}
          </span>
        </div>
      </div>
    </div>;
}